import transitionStyles from '../shared/stylesheets/transitions.css'

export const transitionManager = (
  currentElement,
  previousElement,
  direction = 'forwards'
) => {
  if (!previousElement || previousElement === currentElement) {
    const transitionClass = currentElement.props.transition

    currentElement.backgroundElement.classList.add(transitionStyles.animateInto)
    currentElement.backgroundElement.classList.add(transitionClass)
    return
  }

  const allTransitionClasses = Object.keys(transitionStyles).map(
    key => transitionStyles[key]
  )

  const transitionClass =
    direction === 'forwards' ?
      currentElement.props.transition :
      previousElement.props.transition

  allTransitionClasses.forEach(tClass => {
    previousElement.backgroundElement.classList.remove(tClass)
    currentElement.backgroundElement.classList.remove(tClass)
  })

  previousElement.backgroundElement.classList.add(transitionStyles.animateAway)
  previousElement.backgroundElement.classList.add(transitionClass)

  currentElement.backgroundElement.classList.add(transitionStyles.animateInto)
  currentElement.backgroundElement.classList.add(transitionClass)
}



// WEBPACK FOOTER //
// ./src/client/transitionManager.js